/**
 * Fix para menú móvil en Safari
 * Safari tiene problemas con eventos click en ciertos elementos
 * Este script añade soporte para eventos táctiles y mejora la compatibilidad
 */

(function() {
  'use strict';
  
  // Detectar Safari
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  if (isSafari) {
    // El icono de búsqueda ya no se oculta en Safari móvil
    // Listener para abrir el minicart en Safari al hacer click en .js-call-minicart
    var minicartTriggers = document.querySelectorAll('.js-call-minicart');
    minicartTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var minicart = document.getElementById('minicart-mobile');
        var minicartBg = document.querySelector('.bg-minicart');
        var minicartMenu = document.querySelector('.minicart');
        if (minicart) minicart.classList.add('active');
        if (minicartBg) minicartBg.classList.add('active');
          if (minicartMenu) minicartMenu.classList.add('active');
      });
    });
    // Mostrar alert al hacer click en cualquier .js-call-minicart
    var minicartTriggers = document.querySelectorAll('.js-call-minicart');
    minicartTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        alert('Click en js-call-minicart');
      });
    });
    // Mostrar alert en móvil al hacer click en #minicart-mobile
    function isMobile() {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    var minicartMobile = document.getElementById('minicart-mobile');
    if (minicartMobile && isMobile()) {
      // minicartMobile.addEventListener('click', function(e) {
      //   alert('Minicart clickeado en móvil');
      // });
    }
    console.log('Safari detected - applying menu fixes');
    
    // Variable para rastrear si el touch ya fue manejado
    var touchHandled = false;
    
    // Fix para el menú móvil - usar touchstart en lugar de solo click
    var menuleft = document.querySelector('.menuleft');
    var menuBackground = document.querySelector('.box_contentmenu_background');
    var closeButton = document.querySelector('.js-eveland-close');
    
    // Función para abrir/cerrar el menú
    function toggleMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Prevenir que se ejecute múltiples veces
      if (touchHandled) {
        return;
      }
      touchHandled = true;
      
      var menuleftEl = document.querySelector('.menuleft');
      var menuContent = document.querySelector('.box_contentmenu');
      var menuBg = document.querySelector('.box_contentmenu_background');
      var body = document.body;
      
      if (menuleftEl) menuleftEl.classList.toggle('active');
      if (menuContent) menuContent.classList.toggle('active');
      if (menuBg) menuBg.classList.toggle('active');
      if (body) body.classList.add('activemenu_mobile');
      
      // Resetear después de un pequeño delay
      setTimeout(function() {
        touchHandled = false;
      }, 500);
    }
    
    // Función para cerrar el menú
    function closeMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Prevenir que se ejecute múltiples veces
      if (touchHandled) {
        return;
      }
      touchHandled = true;
      
      var menuleftEl = document.querySelector('.menuleft');
      var menuContent = document.querySelector('.box_contentmenu');
      var menuBg = document.querySelector('.box_contentmenu_background');
      var body = document.body;
      
      if (menuleftEl) menuleftEl.classList.remove('active');
      if (menuContent) menuContent.classList.remove('active');
      if (menuBg) menuBg.classList.remove('active');
      if (body) body.classList.remove('activemenu_mobile');
      
      // Resetear después de un pequeño delay
      setTimeout(function() {
        touchHandled = false;
      }, 500);
    }
    
    // Añadir eventos táctiles para Safari
    if (menuleft) {
      // Remover eventos jQuery existentes
      if (window.jQuery) {
        window.jQuery(menuleft).off('click');
      }
      
      menuleft.style.cursor = 'pointer';
      menuleft.style.webkitTapHighlightColor = 'transparent';
      
      // Solo usar touchend para evitar conflictos
      menuleft.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu(e);
      }, { passive: false });
      
      // Bloquear el evento click en Safari
      menuleft.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    }
    
    if (menuBackground) {
      // Remover eventos jQuery existentes
      if (window.jQuery) {
        window.jQuery(menuBackground).off('click');
      }
      
      menuBackground.style.cursor = 'pointer';
      
      menuBackground.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu(e);
      }, { passive: false });
      
      menuBackground.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    }
    
    if (closeButton) {
      // Remover eventos jQuery existentes
      if (window.jQuery) {
        window.jQuery(closeButton).off('click');
      }
      
      closeButton.style.cursor = 'pointer';
      
      closeButton.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu(e);
      }, { passive: false });
      
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    }
    
    // Fix para submenús - Variable para rastrear clicks
    var submenuTouchHandled = false;
    
    // Esperar a que los botones estén en el DOM (pueden cargarse después)
    function setupSubmenuButtons() {
      var toggleButtons = document.querySelectorAll('.toggle-menumobile, .js_icon_horizon-menu');
      
      toggleButtons.forEach(function(btn) {
        // Verificar si ya tiene el evento aplicado
        if (btn.getAttribute('data-safari-fixed')) {
          return;
        }
        btn.setAttribute('data-safari-fixed', 'true');
        
        btn.style.cursor = 'pointer';
        btn.style.webkitTapHighlightColor = 'transparent';
        
        // Remover eventos jQuery existentes
        if (window.jQuery) {
          window.jQuery(btn).off('click');
        }
        
        btn.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (submenuTouchHandled) {
            return;
          }
          submenuTouchHandled = true;
          
          // Usar jQuery si está disponible para mantener la funcionalidad original
          if (window.jQuery) {
            window.jQuery(btn).parents().addClass('active');
          } else {
            // Fallback sin jQuery
            var parent = btn.parentElement;
            if (parent) {
              parent.classList.add('active');
            }
          }
          
          setTimeout(function() {
            submenuTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        // Bloquear click en Safari
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
      });
    }
    
    // Fix para botones de "volver" en submenús
    function setupBackButtons() {
      var backButtons = document.querySelectorAll('.js-back');
      
      backButtons.forEach(function(btn) {
        if (btn.getAttribute('data-safari-fixed')) {
          return;
        }
        btn.setAttribute('data-safari-fixed', 'true');
        
        btn.style.cursor = 'pointer';
        btn.style.webkitTapHighlightColor = 'transparent';
        
        if (window.jQuery) {
          window.jQuery(btn).off('click');
        }
        
        btn.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (submenuTouchHandled) {
            return;
          }
          submenuTouchHandled = true;
          
          if (window.jQuery) {
            window.jQuery(btn).parents().parents().find('.menu-horizon-list').removeClass('active');
          } else {
            var parent = btn.parentElement;
            if (parent && parent.parentElement) {
              var menuItems = parent.parentElement.querySelectorAll('.menu-horizon-list');
              menuItems.forEach(function(item) {
                item.classList.remove('active');
              });
            }
          }
          
          setTimeout(function() {
            submenuTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
      });
    }
    
    // Ejecutar inmediatamente
    setupSubmenuButtons();
    setupBackButtons();
    
    // Ejecutar nuevamente después de un delay por si los elementos se cargan tarde
    setTimeout(function() {
      setupSubmenuButtons();
      setupBackButtons();
    }, 1000);
    setTimeout(function() {
      setupSubmenuButtons();
      setupBackButtons();
    }, 2000);
    
    // Observar cambios en el DOM para nuevos botones
    var observer = new MutationObserver(function() {
      setupSubmenuButtons();
      setupBackButtons();
    });
    
    var menuContentObs = document.querySelector('.box_contentmenu');
    if (menuContentObs) {
      observer.observe(menuContentObs, {
        childList: true,
        subtree: true
      });
    }
    
    // Fix para tabs
    var tabTouchHandled = false;
    var tabLinks = document.querySelectorAll('.tab_navar, .tab_navar_right');
    tabLinks.forEach(function(tab) {
      tab.style.cursor = 'pointer';
      tab.style.webkitTapHighlightColor = 'transparent';
      
      if (window.jQuery) {
        window.jQuery(tab).off('click');
      }
      
      tab.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        if (tabTouchHandled) {
          return;
        }
        tabTouchHandled = true;
        
        // Simular el click de jQuery/Bootstrap
        if (window.jQuery) {
          window.jQuery(tab).tab('show');
        }
        
        setTimeout(function() {
          tabTouchHandled = false;
        }, 300);
        
        return false;
      }, { passive: false });
      
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    });
    
    // Fix para iconos del carrito y búsqueda en menuright
    var iconTouchHandled = false;
    
    function setupMenuRightIcons() {
      var searchIcon = document.querySelector('.js-search-destop');
      var cartIcon = document.querySelector('.js-call-minicart');
      
      console.log('Safari: Setting up menu right icons');
      console.log('Safari: Search icon found:', searchIcon);
      console.log('Safari: Cart icon found:', cartIcon);
      
      // Fix para el icono de búsqueda (es un span, necesita tratamiento especial)
      if (searchIcon && !searchIcon.getAttribute('data-safari-fixed')) {
        searchIcon.setAttribute('data-safari-fixed', 'true');
        searchIcon.style.cursor = 'pointer';
        searchIcon.style.webkitTapHighlightColor = 'transparent';
        searchIcon.style.pointerEvents = 'auto';
        searchIcon.style.userSelect = 'none';
        searchIcon.style.webkitUserSelect = 'none';
        
        // Remover todos los eventos jQuery previos
        if (window.jQuery) {
          window.jQuery(searchIcon).off('click touchstart touchend');
        }
        
        // Variable local para este icono específico
        var searchTouchHandled = false;
        
        searchIcon.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (searchTouchHandled) {
            console.log('Safari: Search touch already handled, ignoring');
            return;
          }
          searchTouchHandled = true;
          
          console.log('Safari: Search icon touched - opening search');
          
          // Buscar los elementos de búsqueda
          var searchBox = document.querySelector('.js-box-search');
          var searchBg = document.querySelector('.bg_search_box');
          var body = document.body;
          
          console.log('Safari: Search box found:', searchBox);
          console.log('Safari: Search bg found:', searchBg);
          
          // Replicar la funcionalidad de búsqueda
          if (window.jQuery) {
            console.log('Safari: Using jQuery to activate search');
            window.jQuery('.js-box-search').addClass('active');
            window.jQuery('.bg_search_box').addClass('active');
            window.jQuery('body').addClass('activedestop');
          } else {
            console.log('Safari: Using vanilla JS to activate search');
            if (searchBox) searchBox.classList.add('active');
            if (searchBg) searchBg.classList.add('active');
            body.classList.add('activedestop');
          }
          
          // Verificar que se agregaron las clases
          setTimeout(function() {
            var searchBoxCheck = document.querySelector('.js-box-search');
            console.log('Safari: Search box has active class:', searchBoxCheck ? searchBoxCheck.classList.contains('active') : 'not found');
          }, 100);
          
          setTimeout(function() {
            searchTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        // Prevenir touchstart también
        searchIcon.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });
        
        searchIcon.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('Safari: Search icon click blocked');
          return false;
        }, true);
        
        console.log('Safari: Search icon fixed successfully');
      } else if (!searchIcon) {
        console.log('Safari: Search icon NOT FOUND in DOM');
      }
      
      // Fix para el icono del carrito
      if (cartIcon && !cartIcon.getAttribute('data-safari-fixed')) {
        cartIcon.setAttribute('data-safari-fixed', 'true');
        cartIcon.style.cursor = 'pointer';
        cartIcon.style.webkitTapHighlightColor = 'transparent';
        cartIcon.style.pointerEvents = 'auto';
        cartIcon.style.userSelect = 'none';
        cartIcon.style.webkitUserSelect = 'none';
        
        if (window.jQuery) {
          window.jQuery(cartIcon).off('click touchstart touchend');
        }
        
        var cartTouchHandled = false;
        
        cartIcon.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (cartTouchHandled) {
            console.log('Safari: Cart touch already handled, ignoring');
            return;
          }
          cartTouchHandled = true;
          
          // Abrir el minicart directamente usando el nuevo id
          var minicart = document.getElementById('minicart-mobile');
          var minicartBg = document.querySelector('.bg-minicart');
          if (minicart) minicart.classList.add('active');
          if (minicartBg) minicartBg.classList.add('active');
          
          setTimeout(function() {
            cartTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        cartIcon.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });
        
        cartIcon.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
        
        console.log('Safari: Cart icon fixed successfully');
      } else if (!cartIcon) {
        console.log('Safari: Cart icon NOT FOUND in DOM');
      }
    }
    
    // Ejecutar setup de iconos
    setupMenuRightIcons();
    setTimeout(setupMenuRightIcons, 1000);
    setTimeout(setupMenuRightIcons, 2000);
    
    // Fix para cerrar el carrito cuando se da click en el background
    function setupCartCloseButtons() {
  var cartBg = document.querySelector('.bg-minicart');
  var closeCartBtn = document.querySelector('.close-mini-cart');
  var minicartMenu = document.querySelector('.minicart');
      
      var closeTouchHandled = false;
      
      if (cartBg && !cartBg.getAttribute('data-safari-fixed')) {
        cartBg.setAttribute('data-safari-fixed', 'true');
        cartBg.style.cursor = 'pointer';
        
        if (window.jQuery) {
          window.jQuery(cartBg).off('click touchend');
        }
        
        cartBg.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (closeTouchHandled) {
            return;
          }
          closeTouchHandled = true;
          
          console.log('Safari: Cart background touched - closing cart');
          
          if (window.jQuery) {
            window.jQuery('#minicart-mobile').removeClass('active');
            window.jQuery('.bg-minicart').removeClass('active');
          } else {
            var minicart = document.getElementById('minicart-mobile');
            var minicartBg = document.querySelector('.bg-minicart');
            if (minicart) minicart.classList.remove('active');
            if (minicartBg) minicartBg.classList.remove('active');
          }
          
          setTimeout(function() {
            closeTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        cartBg.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
        
        console.log('Safari: Cart background close fixed');
      }
      
      if (closeCartBtn && !closeCartBtn.getAttribute('data-safari-fixed')) {
        closeCartBtn.setAttribute('data-safari-fixed', 'true');
        closeCartBtn.style.cursor = 'pointer';
        
        if (window.jQuery) {
          window.jQuery(closeCartBtn).off('click touchend');
        }
        
        closeCartBtn.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (closeTouchHandled) {
            return;
          }
          closeTouchHandled = true;
          
          console.log('Safari: Cart close button touched');
          
          if (window.jQuery) {
            window.jQuery('#minicart-mobile').removeClass('active');
            window.jQuery('.bg-minicart').removeClass('active');
            window.jQuery('.minicart').removeClass('active');
          } else {
            var minicart = document.getElementById('minicart-mobile');
            var minicartBg = document.querySelector('.bg-minicart');
            var minicartMenu = document.querySelector('.minicart');
            if (minicart) minicart.classList.remove('active');
            if (minicartBg) minicartBg.classList.remove('active');
            if (minicartMenu) minicartMenu.classList.remove('active');
          }
          
          setTimeout(function() {
            closeTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        closeCartBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
        
        console.log('Safari: Cart close button fixed');
      }
    }
    
    // Ejecutar setup de botones de cerrar
    setupCartCloseButtons();
    setTimeout(setupCartCloseButtons, 1000);
    setTimeout(setupCartCloseButtons, 2000);
    
    // Fix para cerrar la búsqueda
    function setupSearchCloseButtons() {
      var searchBg = document.querySelector('.bg_search_box');
      var closeSearchBtn = document.querySelector('.js-drawer-close');
      
      var searchCloseTouchHandled = false;
      
      if (searchBg && !searchBg.getAttribute('data-safari-fixed')) {
        searchBg.setAttribute('data-safari-fixed', 'true');
        searchBg.style.cursor = 'pointer';
        
        if (window.jQuery) {
          window.jQuery(searchBg).off('click touchend');
        }
        
        searchBg.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (searchCloseTouchHandled) {
            return;
          }
          searchCloseTouchHandled = true;
          
          console.log('Safari: Search background touched - closing search');
          
          if (window.jQuery) {
            window.jQuery('.js-box-search').removeClass('active');
            window.jQuery('.bg_search_box').removeClass('active');
            window.jQuery('body').removeClass('activedestop');
          } else {
            var searchBox = document.querySelector('.js-box-search');
            var searchBgEl = document.querySelector('.bg_search_box');
            if (searchBox) searchBox.classList.remove('active');
            if (searchBgEl) searchBgEl.classList.remove('active');
            document.body.classList.remove('activedestop');
          }
          
          setTimeout(function() {
            searchCloseTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        searchBg.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
        
        console.log('Safari: Search background close fixed');
      }
      
      if (closeSearchBtn && !closeSearchBtn.getAttribute('data-safari-fixed')) {
        closeSearchBtn.setAttribute('data-safari-fixed', 'true');
        closeSearchBtn.style.cursor = 'pointer';
        
        if (window.jQuery) {
          window.jQuery(closeSearchBtn).off('click touchend');
        }
        
        closeSearchBtn.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          if (searchCloseTouchHandled) {
            return;
          }
          searchCloseTouchHandled = true;
          
          console.log('Safari: Search close button touched');
          
          if (window.jQuery) {
            window.jQuery('.js-box-search').removeClass('active');
            window.jQuery('.bg_search_box').removeClass('active');
            window.jQuery('body').removeClass('activedestop');
          } else {
            var searchBox = document.querySelector('.js-box-search');
            var searchBgEl = document.querySelector('.bg_search_box');
            if (searchBox) searchBox.classList.remove('active');
            if (searchBgEl) searchBgEl.classList.remove('active');
            document.body.classList.remove('activedestop');
          }
          
          setTimeout(function() {
            searchCloseTouchHandled = false;
          }, 300);
          
          return false;
        }, { passive: false });
        
        closeSearchBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }, true);
        
        console.log('Safari: Search close button fixed');
      }
    }
    
    // Ejecutar setup de botones de cerrar búsqueda
    setupSearchCloseButtons();
    setTimeout(setupSearchCloseButtons, 1000);
    setTimeout(setupSearchCloseButtons, 2000);
    
    // Mejorar z-index para evitar problemas de overlay en Safari
    var menuContent = document.querySelector('.box_contentmenu');
    if (menuContent) {
      menuContent.style.webkitTransform = 'translateZ(0)';
      menuContent.style.transform = 'translateZ(0)';
    }
    
    console.log('Safari menu fixes applied');
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('Safari menu fix loaded');
    });
  }
})();
